<!-- filtrado de reportes -->
<app-filtros-reporte>
  <form class="space-y-3 sm:space-y-4" (submit)="aplicarFiltros($event)">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-3 sm:gap-4">
      <!-- Rango de fechas y tipo movimiento -->
      <div>
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-calendar-range"></i>
          Rango de fechas
        </label>
        <div class="flex items-center rounded-lg border border-slate-200 bg-white transition-all duration-150 focus-within:ring-2 focus-within:ring-accent-500/20 focus-within:border-accent-500 hover:border-slate-300">
          <span class="flex items-center justify-center pl-3 pr-2 text-slate-400 shrink-0">
            <i class="bi bi-calendar text-sm"></i>
          </span>
          <app-datepicker
            class="flex-1"
            [borderless]="true"
            [formField]="$any(formFiltro.rangoFecha)"
            selectionMode="range"
            [maxDate]="maxDate"
            placeholder="Seleccione un rango"
            dateFormat="dd/mm/yy"
            [minDate]="minDate"
            [showButtonBar]="true"
            [invalid]="formFiltro.rangoFecha().touched() && formFiltro.rangoFecha().invalid()"
          />
        </div>
        @if (formFiltro.rangoFecha().touched() && formFiltro.rangoFecha().invalid()) {
          <small class="text-sm text-red-600">{{ formFiltro.rangoFecha().errors() | formErrorMessage }}</small>
        }
      </div>
      <!-- Tipo de movimiento -->
      <div class="sm:col-span-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-arrow-left-right"></i>
          Tipo de movimiento
        </label>
        <app-select
          class="w-full"
          [options]="opcionesTipoMovimiento()"
          [formField]="$any(formFiltro.tipo_movimiento)"
          placeholder="Seleccione tipo de movimiento"
        />
      </div>
      <!-- Usuario -->
      <div class="sm:col-span-2 lg:col-span-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-person-circle"></i>
          Empleado
        </label>
        <app-select
          class="w-full"
          [filter]="opcionesEmpleado().length > 10"
          filterBy="label"
          emptyFilterMessage="No se encontraron empleados."
          [loading]="!opcionesEmpleado().length"
          [options]="opcionesEmpleado()"
          [formField]="$any(formFiltro.empleado)"
          placeholder="Seleccione un empleado"
        />
      </div>
      <!-- sucursal -->
      <div>
        <label class="block text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-geo-alt"></i>
          Sucursal
        </label>
        <app-select
          class="w-full"
          [filter]="opcionesSucursal().length > 10"
          filterBy="label"
          emptyFilterMessage="No se encontraron sucursales."
          [loading]="!opcionesSucursal().length"
          [options]="opcionesSucursal()"
          [formField]="$any(formFiltro.sucursal)"
          placeholder="Seleccione una sucursal"
        />
      </div>
    </div>

    <!-- Botones de acción -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <button
        type="submit"
        class="flex-1 px-4 py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 text-sm"
      >
        <i class="bi bi-search"></i>
        <span>Buscar</span>
      </button>
      <button
        type="button"
        (click)="limpiarFiltros()"
        class="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors flex items-center justify-center gap-2 text-sm"
      >
        <i class="bi bi-arrow-clockwise"></i>
        <span>Limpiar</span>
      </button>
      <button
        type="button"
        (click)="exportarExcel()"
        class="flex-1 px-4 py-2.5 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors flex items-center justify-center gap-2 text-sm"
      >
        <i class="bi bi-file-earmark-excel"></i>
        <span>Excel</span>
      </button>
    </div>
  </form>
</app-filtros-reporte>
<!-- tabla -->
<app-tabla
  titulo="Reporte kardex"
  [columnas]="columnasTabla"
  [datos]="paginacion()?.data || []"
  [accionesTemplate]="accionesTemplate"
/>
<ng-template #accionesTemplate let-row>
  <button
    type="button"
    class="text-blue-600 hover:text-blue-800 font-medium text-sm inline-flex items-center gap-1 transition-colors"
    (click)="verDetallesKardex(row)"
  >
    <i class="bi bi-eye"></i>
    <span class="hidden sm:inline">Ver</span>
  </button>
</ng-template>
<ng-template #movimientoTemplate let-row>
  @switch (row.tipo_movimiento) {
    @case (ETipoMovimientoKardex.INGRESO) {
      <span class="px-2 py-1 bg-green-100 text-green-800 text-xs font-semibold rounded-full">
        Ingreso
      </span>
    }
    @case (ETipoMovimientoKardex.EGRESO) {
      <span class="px-2 py-1 bg-red-100 text-red-800 text-xs font-semibold rounded-full">
        Egreso
      </span>
    }
    @case (ETipoMovimientoKardex.COMPRA) {
      <span class="px-2 py-1 bg-green-100 text-green-800 text-xs font-semibold rounded-full">
        Compra
      </span>
    }
    @case (ETipoMovimientoKardex.VENTA) {
      <span class="px-2 py-1 bg-red-100 text-red-800 text-xs font-semibold rounded-full">
        Venta
      </span>
    }
    @case (ETipoMovimientoKardex.DEVOLUCION) {
      <span class="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs font-semibold rounded-full">
        Devolución
      </span>
    }
    @default {
      <span class="px-2 py-1 bg-gray-100 text-gray-800 text-xs font-semibold rounded-full">
        Desconocido
      </span>
    }
  }
</ng-template>
<!-- sucursal -->
<ng-template #sucursalColumnTemplate let-row>
  {{ row.sucursal_id | nombreSucursal }}
</ng-template>
<!-- paginar -->
@if (paginacion() != null) {
  <app-paginacion
    [items]="paginacion()!.data"
    [itemsPorPagina]="paginacion()!.size"
    [totalItems]="paginacion()!.total"
    (paginaCambiada)="cambiarPagina($event)"
  />
}
<app-dialog
  header="Detalles kardex"
  [modal]="true"
  [closeOnEscape]="true"
  size="lg"
  styleClass="w-[90vw] max-w-[600px]"
  [visible]="modal_detalles_kardex()"
  (visibleChange)="modal_detalles_kardex.set($event)"
  (onHide)="kardex_seleccionado = null; modal_detalles_kardex.set(false)"
>
  @if (modal_detalles_kardex() == true && kardex_seleccionado != null) {
    <div class="space-y-6">
      <!-- Tipo de Movimiento y Fecha -->
      <div class="flex items-center justify-between border-b border-gray-200 pb-4">
        <div>
          <p class="text-sm text-gray-500 mb-1">Sucursal</p>
          <p class="text-sm font-medium text-gray-900">
            {{ kardex_seleccionado.sucursal_id | nombreSucursal }}
          </p>
        </div>
        <div>
          <p class="text-sm text-gray-500 mb-1">Tipo de movimiento</p>
          @switch (kardex_seleccionado.tipo_movimiento) {
            @case (ETipoMovimientoKardex.INGRESO) {
              <span
                class="px-3 py-1.5 bg-green-100 text-green-800 text-sm font-semibold rounded-full"
              >
                <i class="bi bi-arrow-down-circle"></i> Ingreso
              </span>
            }
            @case (ETipoMovimientoKardex.EGRESO) {
              <span class="px-3 py-1.5 bg-red-100 text-red-800 text-sm font-semibold rounded-full">
                <i class="bi bi-arrow-up-circle"></i> Egreso
              </span>
            }
            @case (ETipoMovimientoKardex.COMPRA) {
              <span
                class="px-3 py-1.5 bg-blue-100 text-blue-800 text-sm font-semibold rounded-full"
              >
                <i class="bi bi-cart-plus"></i> Compra
              </span>
            }
            @case (ETipoMovimientoKardex.VENTA) {
              <span
                class="px-3 py-1.5 bg-purple-100 text-purple-800 text-sm font-semibold rounded-full"
              >
                <i class="bi bi-cash-coin"></i> Venta
              </span>
            }
            @case (ETipoMovimientoKardex.DEVOLUCION) {
              <span
                class="px-3 py-1.5 bg-yellow-100 text-yellow-800 text-sm font-semibold rounded-full"
              >
                <i class="bi bi-arrow-counterclockwise"></i> Devolución
              </span>
            }
            @default {
              <span
                class="px-3 py-1.5 bg-gray-100 text-gray-800 text-sm font-semibold rounded-full"
              >
                Desconocido
              </span>
            }
          }
        </div>
        <div class="text-right">
          <p class="text-sm text-gray-500 mb-1">Fecha</p>
          <p class="text-sm font-medium text-gray-900">
            {{ kardex_seleccionado.fecha | date: 'dd/MM/yyyy HH:mm:ss' }}
          </p>
        </div>
      </div>
      <!-- Producto -->
      <div class="bg-gray-50 rounded-lg p-4">
        <h4 class="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
          <i class="bi bi-box-seam text-blue-600"></i>
          Información del Producto
        </h4>
        <div class="space-y-2">
          <div class="flex justify-between">
            <span class="text-sm text-gray-600">Nombre:</span>
            <span class="text-sm font-medium text-gray-900">{{
              kardex_seleccionado.producto.nombre
            }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-sm text-gray-600">Código:</span>
            <span class="text-sm font-medium text-gray-900">{{
              kardex_seleccionado.producto.codigo
            }}</span>
          </div>
        </div>
      </div>

      <!-- Cantidades y Montos -->
      <div class="grid grid-cols-2 gap-4">
        <div class="bg-blue-50 rounded-lg p-4">
          <p class="text-xs text-blue-600 font-medium mb-1">Cantidad</p>
          <p class="text-2xl font-bold text-blue-900">{{ kardex_seleccionado.cantidad }}</p>
        </div>
        <div class="bg-green-50 rounded-lg p-4">
          <p class="text-xs text-green-600 font-medium mb-1">Precio Unitario</p>
          <p class="text-2xl font-bold text-green-900">
            {{ kardex_seleccionado.precio_unitario | currency: 'PEN' : 'S/. ' }}
          </p>
        </div>
        <div class="bg-purple-50 rounded-lg p-4">
          <p class="text-xs text-purple-600 font-medium mb-1">Total</p>
          <p class="text-2xl font-bold text-purple-900">
            {{ kardex_seleccionado.total | currency: 'PEN' : 'S/. ' }}
          </p>
        </div>
        <div class="bg-amber-50 rounded-lg p-4">
          <p class="text-xs text-amber-600 font-medium mb-1">Saldo en stock</p>
          <p class="text-2xl font-bold text-amber-900">{{ kardex_seleccionado.saldo }} Und.</p>
        </div>
      </div>

      <!-- Concepto -->
      <div class="bg-gray-50 rounded-lg p-4">
        <h4 class="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
          <i class="bi bi-chat-left-text text-gray-600"></i>
          Concepto
        </h4>
        <p class="text-sm text-gray-800">{{ kardex_seleccionado.concepto }}</p>
      </div>

      <!-- Empleado -->
      <div class="bg-gray-50 rounded-lg p-4">
        <h4 class="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
          <i class="bi bi-person-circle text-indigo-600"></i>
          Empleado Responsable
        </h4>
        <div class="space-y-2">
          <div class="flex justify-between">
            <span class="text-sm text-gray-600">Nombre:</span>
            <span class="text-sm font-medium text-gray-900">
              {{ kardex_seleccionado.empleado.nombre_completo }}
            </span>
          </div>
          <div class="flex justify-between">
            <span class="text-sm text-gray-600">Email:</span>
            <span class="text-sm font-medium text-gray-900">{{
              kardex_seleccionado.empleado.email
            }}</span>
          </div>
        </div>
      </div>
    </div>
  }
</app-dialog>
